export default __webpack_public_path__ + "static/media/balmain.3df52ade.jpg";